import { styled } from 'styled-components'

export const Navigation = styled.ul`
  align-items: center;
  display: flex;
  gap: 1rem;
  height: 100%;
`

export const NavigationItem = styled.li`
  align-items: center;
  display: flex;
  height: inherit;
  justify-content: center;

  & > button {
    height: auto;
    width: auto;
  }
`
